<template lang='pug'>
.video-view-container
    video(
        playsinline,
        controls,
        v-src='info.link',
        @play='catchEvent',
        @pause='catchEvent',
        @ended='catchEvent',
        :data-poster='info.banner ? info.banner : null'
    )
    .content
        .row
            .bold-title {{ info.name }}
            img(
                src='@/assets/imgs/star.png',
                @click.stop='_book',
                v-if='bookId'
            )
            img(src='@/assets/imgs/unstar.png', @click.stop='_book', v-else)
        .desc {{ info.desc }}
</template>

<script>
import book from '@/views/mixin/book'
import { concatWithSymbol, getDataRow, getPathNames, updateWxShareData, videoview } from '@custouch/proxy-use'
export default {
    mixins: [book],
    props: ['rId','hId'],
    data() {
        return {
            info: {},
            title: '',
            tagIds: []
        }
    },
    methods: {
        catchEvent({ target: { duration, event, currentTime }, type }) {
            this.$root.$emit('actionView', {
                type: 'videoview', params: {
                    name: this.info.name,
                    source: this.info.link,
                    event: type,
                    duration,
                    currentTime,
                    title: this.title,
                    tagIds: this.tagIds.join(',')
                }
            })
        }
    },
    async created() {
        const ret = await getDataRow({dataRowId: this.rId})
        this.info = Object.assign({rId: ret.id},ret.detail)
        let title = concatWithSymbol([this.$route.meta.title,ret.detail.name])
        if(this.hId){
            title = await getPathNames(this.hId,ret.detail.name)
        }
        this.title = title
        this.tagIds = ret.tagIds
        this.$root.$emit('pageview',{
            title,
            tagIds: ret.tagIds.join(',')
        })
        const { LOGO } = window.env
        updateWxShareData({
            title: ret.detail.name,
            desc: '点击查看详情',
            imgUrl: LOGO
        })
        // const data = await this.$store.dispatch('getJson', window.env.VUE_APP_DATA_DOCUMENT)
        // const { id } = this.$route.params
        // this.info = data.find(item => item.type === 'video' && item.id == id)
        // this.$updateWxShareData({
        //     title: this.info.name,
        //     description: '点击查看详情',
        //     image: window.location.href.split(/[?#]/)[0] + 'logo.jpg'
        // })
    }
}
</script>

<style scoped lang='less'>
.content {
    padding: 1.2rem 1rem;
    .row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
            width: 1.1rem;
            object-fit: contain;
        }
    }
}
video {
    width: 100%;
}
</style>